export default __webpack_public_path__ + "8f7527bdfd2fba438b5be4477282f8ce.png";